import { Typography } from '@mui/material';
import { GridColumnHeaderParams } from '@mui/x-data-grid';

const ColumnHeader = (params: GridColumnHeaderParams) => {
  return (
    <Typography variant="bodyDefaultStrong" sx={{ whiteSpace: 'break-spaces' }}>
      {params.colDef.headerName}
    </Typography>
  );
};

export default ColumnHeader;
